import * as next from '../../../types/next'
import { CONTROL_NAME, getBlockNameByScope } from '../../../utils'
import type { UpBlockHandler } from '../types'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.BinaryBlock> = (uischema, schema) => {
  if (uischema.type !== CONTROL_NAME.CONTROL) {
    throw new Error('Expected a valid Binary Input control')
  }

  const name = String(
    getBlockNameByScope(uischema.scope) ?? uischema.options?.title
  )

  return {
    type: next.BLOCK_TYPE.BINARY_INPUT,
    settings: {
      ...upCommonSettings(uischema),
      default: schema.properties?.[name]?.default,
      mode: uischema.options?.toggle
        ? next.BINARY_BLOCK_MODE.SWITCH
        : next.BINARY_BLOCK_MODE.CHECKBOX
    }
  }
}
